import { IonApp, IonContent, IonPage } from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import ChangePasswordSuccess from "components/mobile-components/Profile/ChangePasswordSuccess";
import React from "react";
import { useSelector } from "react-redux";

export default function ChangePasswordSuccessPage() {
	const ekkLanguage = useSelector((state) => state.lan.lan);
	return (
		<IonApp>
			<IonPage className='business-name'>
				<IonContent>
					<BackButtonTitle title={ekkLanguage.changePassword.pageTitle} />
					<ChangePasswordSuccess />
				</IonContent>
			</IonPage>
		</IonApp>
	);
}
